import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useApi } from '../ApiContext';
import './Maintenance.css'; // Pastikan abang import fail CSS ini

const Maintenance = () => {
    const { api } = useApi();
    const [isActive, setIsActive] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const res = await api.get('/maintenance/maintenance-status'); 
                setIsActive(Number(res.data.is_active));
            } catch (err) { console.error(err); }
        };
        fetchStatus();
    }, [api]);

    const handleToggle = async () => {
        const newStatus = isActive === 1 ? 0 : 1;
        setLoading(true);
        try {
            await api.put('/maintenance/toggle', { status: newStatus });
            setIsActive(newStatus);
            toast.success('Maintenance status updated!');
        } catch (err) { toast.error('Update failed'); }
        finally { setLoading(false); }
    };

    return (
        <div className="maint-wrapper">
            <Toaster />
            <h2 className="maint-title">System Maintenance Control</h2>
            <div className="maint-card">
                <p className="maint-status-text">
                    <strong>Current Mode:</strong> {isActive === 1 ? 'MAINTENANCE ON' : 'NORMAL (OFF)'}
                </p>
                <button 
                    className={`maint-btn ${isActive === 1 ? 'maint-btn-off' : 'maint-btn-on'}`}
                    onClick={handleToggle} 
                    disabled={loading}
                >
                    {loading ? 'Processing...' : (isActive === 1 ? 'Turn Maintenance OFF' : 'Turn Maintenance ON')}
                </button>
            </div>
        </div>
    );
};

export default Maintenance;